<template>
  <div>
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
          Prazos de Vencimento LRFCI
          <b-button size="sm" class="float-right m-1" to="/seguranca-administracao/prazos-vencimento-lrf/novo">
            <font-awesome-icon icon="plus" class="mr-3" />
            Novo prazo LRFCI
          </b-button>
        </h6>
      </template>
      <b-card-body>
        <card-filtros-busca>
          <b-form @submit.prevent="buscarPrazos" @reset.prevent="limparFiltros" v-if="showFilters">
            <b-row>
              <b-col cols="12" md="6" lg="4">
                <b-form-group id="input-group-filtro" label-size="md" label="Busca Geral">
                  <b-form-input v-model="filtros.filtro"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="4">
                <b-form-group id="input-group-exercicio" label-size="md" label="Exercício (ano)">
                  <b-form-select id="select-filtros-exercicio" v-model="filtros.exercicio" :options="comboExercicios">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="4">
                <b-form-group id="input-group-periodo-prestacao" label-size="md" label="Período Prestação">
                  <b-form-select id="select-filtros-periodo-prestacao" v-model="filtros.periodoPrestacao"
                    :options="comboPeriodosPrestacao">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" offset="3" offset-md="0" lg="4">
                <b-form-group id="input-group-periodo-relatorio" label-size="md" label="Período Relatório">
                  <b-form-select id="select-filtros-periodo-relatorio" v-model="filtros.periodoRelatorio"
                    :options="comboPeriodosRelatorio">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="4" class="pt-4">
                <b-button type="reset" variant="outline-secondary">
                  <font-awesome-icon icon="redo" class="mr-3" />Limpar
                </b-button>
              </b-col>
              <b-col cols="6" lg="4" class="pt-4">
                <b-button type="submit">
                  <font-awesome-icon icon="search" class="mr-3" />Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </card-filtros-busca>
        <b-table :busy="tableBusy" :fields="fields" hover no-border-collapse :items="items" sort-by="" :sort-desc="true"
          striped stacked="sm" per-page="10" :current-page="currentPage" show-empty>
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template #cell(show_details)="row">
            <font-awesome-icon :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'" class="mr-2"
              @click="row.toggleDetails" />
          </template>
          <template #row-details="row">
            <b-card>
              <b-row class="text-justify">
                <b-col cols="6">
                  <span>Justificativa: </span>
                  <span>{{ row.item.Justificativa }}</span>
                </b-col>
                <b-col cols="6">
                  <span>Período de Prestação: </span>
                  <span>{{ row.item.PeriodoPrestacao }}</span>
                </b-col>
              </b-row>
            </b-card>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="actions-icons">
              <b-link class="text-dark" @click="editarPrazo(row.item)">
                <font-awesome-icon icon="edit" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
              <btn-excluir :idItem="row.item.IdVencimentoSagresLrfci" :excluirItem="removerPrazo" />
            </div>
          </template>
        </b-table>
        <b-pagination v-model="currentPage" :total-rows="items.length" per-page="10" aria-controls="my-table" />
      </b-card-body>
    </b-card>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import BtnExcluir from '@/components/shared/btn-excluir.vue'
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue'
import prazosService from "@/services/administracao/prazosService"
import { store } from "@/store"

import { FiltrosPrazoDeVencimentoLRFCI } from '@/types/administracao/prazos-lrfci/filtros-prazo-de-vencimento-lrfci'
import { SelectValue } from '@/types/select-value'
import { fieldsPrazoVencimentoLRFCI } from '@/types/administracao/prazos-lrfci/fields-prazo-de-vencimento-lrfci'
import { TableField } from '@/types/table-field'
import { PrazoDeVencimentoLRFCI } from '@/types/administracao/prazos-lrfci/prazo-de-vencimento-lrfci'

const CompProps = Vue.extend({
  name: 'PrazosDeVencimentoLRFCI',
  components: { BtnExcluir, CardFiltrosBusca },
})

@Component
export default class PrazosDeVencimentoLRFCI extends CompProps {
  comboExercicios: SelectValue[] = []
  comboPeriodosPrestacao: SelectValue[] = []
  comboPeriodosRelatorio: SelectValue[] = []
  currentPage = 1
  fields: TableField[] = fieldsPrazoVencimentoLRFCI
  filtros: FiltrosPrazoDeVencimentoLRFCI = new FiltrosPrazoDeVencimentoLRFCI()
  items: PrazoDeVencimentoLRFCI[] = []
  showFilters = true
  tableBusy = false

  async mounted() {
    try {
      store.blockScreen = true
      const combos = await prazosService.getCombosLRFCI()
      this.comboPeriodosPrestacao = combos.periodosPrestacao.map(p => { return { value: p, text: p } })
      this.comboPeriodosRelatorio = combos.periodosRelatorio.map(p => { return { value: p.IdPeriodorelatorio, text: p.DePeriodorelatorio } })
      this.comboExercicios = combos.exercicios.map(p => { return { value: p, text: p } })
    } finally {
      store.blockScreen = false
    }
  }

  async buscarPrazos(): Promise<void> {
    this.tableBusy = true
    try {
      const response = await prazosService.buscarPrazosVencimentoLRFCI(this.filtros);
      if (response && response.status === 200) {
        this.items = response.data.map((pr: any) => {
          const retorno = Object.assign(new PrazoDeVencimentoLRFCI(), pr)
          retorno.tratarDadosDaAPI()
          return retorno
        })
      } else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!')
      }
    } catch (e: any) {
      console.error(e)
      this.items = []
      this.$toast.error(e.message ? e.message : e);
    } finally {
      this.tableBusy = false
    }
  }
  limparFiltros(): void {
    this.filtros.limpar()
    // Trick to reset/clear native browser form validation state
    this.showFilters = false
    this.$nextTick(() => {
      this.showFilters = true
    })
  }
  async removerPrazo(id: number): Promise<void> {
    try {
      store.blockScreen = true
      const resp = await prazosService.removerPrazoVencimentoLRFCI(id)
      if (resp && resp.status === 204) {
        this.buscarPrazos()
        this.$toast.success("Prazo de LRFCI excluído com sucesso")
      } else {
        console.error('Erro ao remover prazo de LRFCI', resp)
        this.$toast.error(resp.data.msg || 'Erro ao remover prazo de LRFCI')
      }
    } catch (e: any) {
      console.error('Erro ao remover prazo de LRFCI', e)
      this.$toast.error(e.message || 'Erro ao remover prazo de LRFCI')
    } finally {
      store.blockScreen = false
    }
  }
  editarPrazo(prazoAEditar: PrazoDeVencimentoLRFCI) {
    this.$router.push(`/seguranca-administracao/prazos-vencimento-lrf/editar/${prazoAEditar.IdVencimentoSagresLrfci}`);
  }
};
</script>

<style>
</style>